import { css } from 'styled-components';
import { PageNumberProps } from '../../../../../components/Pagination/PageNumber/styles';
import colors, { colorWithOpacity } from '../../../../../helpers/colors';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import { fonts } from '../../../fonts';

const activePageButton = css`
  color: ${colors.neutral01};
  &:hover {
    background-color: ${colors.neutral06};
  }
  &:active {
    background-color: ${colorWithOpacity(colors.core01, 0.2)};
    color: ${colors.neutral01};
    border: 1px solid ${colors.core01};
    box-shadow: 0 0 0 1px ${colors.core01};
  }
  &:focus-visible {
    box-shadow: 0 0 0 1px ${colors.core01}, 0 0 0 3px ${colors.neutral08},
      0 0 0 7px ${colorWithOpacity(colors.core01, 0.6)};
  }
`;

const disabledPageButton = css`
  background-color: ${colors.core01};
  color: ${colors.neutral08};
`;

export default css<PageNumberProps>`
  && {
    border-radius: ${spacing(5)};
    border: none;
    ${fonts.paragraphSmall};
    min-width: ${spacing(5)};
    height: ${spacing(5)};
    min-height: ${spacing(5)};
    line-height: 1.25rem;
    ${({ disabled }) => (disabled ? disabledPageButton : activePageButton)}
    margin: 0 ${spacing(1)};
    ${mediaQuery.tabletLandscape`
      margin: 0 ${spacing(2)};
    `}
  }
`;
